// src/utils/sessionStorage.js


// Session reset logic - resets session tokens every hour
const SESSION_RESET_KEY = 'session_last_reset';
const SESSION_DURATION = 60 * 60 * 1000; // 1 hour in milliseconds

// Simple storage helper
const storage = {
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value.toString());
    } catch (error) {
      console.warn('Storage failed:', error);
    }
  },
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.warn('Storage read failed:', error);
      return null;
    }
  }
};

export const checkAndResetSession = (sessionType = 'vibe') => {
  const lastResetKey = `${sessionType}_${SESSION_RESET_KEY}`;
  const sessionTokensKey = `${sessionType}_session_tokens_used`;
  
  const lastReset = storage.getItem(lastResetKey);
  const now = Date.now();
  
  if (!lastReset || (now - parseInt(lastReset, 10)) >= SESSION_DURATION) {
    // Reset session tokens but keep total spent
    storage.setItem(sessionTokensKey, '0');
    storage.setItem(lastResetKey, now.toString());
    return true; // Session was reset
  }
  
  return false; // No reset needed
};

export const getTimeUntilSessionReset = (sessionType = 'vibe') => {
  const lastResetKey = `${sessionType}_${SESSION_RESET_KEY}`;
  const lastReset = storage.getItem(lastResetKey);
  
  if (!lastReset) {
    return 0;
  }
  
  const elapsed = Date.now() - parseInt(lastReset, 10);
  const remaining = SESSION_DURATION - elapsed;
  
  return Math.max(0, Math.ceil(remaining / (60 * 1000))); // Return minutes remaining
};